import {createContext} from 'react';

const xtareaContext = createContext();

export default xtareaContext;